import {createContext, h} from "preact";
import {useEffect, useMemo, useState} from "preact/hooks";
import scrollIntoView from 'scroll-into-view-if-needed';
import {isArray} from "@src/utils/type-utils";
import Schema from 'async-validator';

export const FormContext = createContext({});

class FormStore {

  constructor({initialValue, onValuesChange}) {
    this.initialValue = initialValue;
    this.onValuesChange = onValuesChange;
  }

  initialValue = {}

  formRule = {}

  setFormFieldErrorList = {}

  fieldRefList = {}

  value = {};

  /**
   * 更新值
   *
   * @type {function}
   */
  changeValue

  /**
   * 检查是否必填
   * @param require
   * @param value
   * @returns {boolean}
   */
  isNeedRequire(require, value) {
    if (require) {
      if (isArray(value)) {
        return !!value.length;
      } else {
        return !!value;
      }
    } else {
      return true;
    }
  }

  /**
   * 检查是否超过长度
   * @param maxLength
   * @param value
   * @returns {boolean}
   */
  isOverLength(maxLength, value) {
    if (maxLength) {
      if (isArray(value)) {
        return !(value.length > maxLength);
      }
      return !(value.length > maxLength);
    } else {
      return true;
    }
  }

  scrollIntoView(name, option) {
    const element = this.fieldRefList[name].current;
    scrollIntoView(element, {
      scrollMode: 'if-needed',
      block: 'nearest',
      inline: 'nearest',
      ...option
    });
  }

  collectField(name) {
    if (!this.initialValue[name]) {
      this.value[name] = '';
    } else {
      this.value[name] = !this.initialValue[name];
    }
  }

  setFieldErrorMsg(name,errors){
    const errMsg = errors ? errors.find(err => Object.keys(err)[0] === name)[name][0] : '';
    this.setFormFieldErrorList[name](errMsg);
  }

  collectFiledRule(name, rule) {
    this.formRule[name] = rule;
  }

  collectFiledError(name, setError) {
    this.setFormFieldErrorList[name] = setError;
  }

  collectFiledRef(name, elementRef) {
    this.fieldRefList[name] = elementRef;
  }

  clearFiledCollectInfo(name) {
    // delete this.initialValue[name];
    delete this.value[name];
    delete this.formRule[name];
    delete this.setFormFieldErrorList[name];
  }

  async validateField(name, value) {
    const validator = new Schema(name ? {[name]: this.formRule[name]} : this.formRule);
    return new Promise((resolve, reject) => {
      validator.validate(value, (errors, fields) => {
        if (errors) {
          reject( Object.keys(fields).reduce((errorList, key) => {
            return [...errorList, {
              [key]: fields[key].map(err => err.message),
            }]
          }, []));
        } else {
          resolve(value);
        }
      });
    })
  }

  async validateFieldsAndScroll(callback) {
    try{
      await this.validateField(null, this.value);
      callback(null, {...this.value});
      Object.keys(this.value).forEach(name => this.setFieldErrorMsg(name, ''));
    } catch(e){
      e.forEach((err,index) => {
        const name = Object.keys(err)[0];
        if(!index) {
          this.scrollIntoView(name);
        }
        this.setFieldErrorMsg(name, e)
      });
      callback(e, {...this.value});
    }
  }

  validateFields(fields,callback) {
    const schema = fields.reduce((_schema, field) => {
      return {
        ..._schema,
        [field]: this.formRule[field]
      }
    }, {})
    const validator = new Schema(schema);
    validator.validate(this.value, errors => {
      if(errors){
        callback(errors);
      } else {
        callback();
      }
    })
  }

  getFieldValue(field){
    return this.value[field] || '';
  }

  onFieldValueChange = (props, value) => {
    this.value = {
      ...this.value,
      ...value,
    }
    this.onValuesChange(props, value, {
      ...this.value,
    });
    this.changeValue(this.value);
  }

  changeFieldValue = async (props, value) => {
    try{
      await this.validateField(props.name, value);
      this.setFieldErrorMsg(props.name, '');
    }catch (e){
      this.setFieldErrorMsg(props.name, e);
    }
    /*this.value = {
      ...this.value,
      ...value
    }
    // this.onValuesChange(props, value, this.value);
    this.changeValue(this.value);*/
  }
}

const Form = ({
                children, initialValue = {}, onValuesChange = () => {
  }, formRef, ...props
              }) => {
  const formStore = useMemo(() => new FormStore({
    initialValue,
    onValuesChange
  }), []);
  const [formValue, setFormValue] = useState({...initialValue});
  useEffect(() => {
    formRef.current = {props: {form: formStore}}
    formStore.changeValue = setFormValue;
  }, [])
  return <form {...props} onSubmit={(e) => e.preventDefault()}>
    <FormContext.Provider value={{
      formStore,
      formValue,
      changeFieldValue: formStore.changeFieldValue
      // changeValue: formStore.changeValue
    }}>
      {children}
    </FormContext.Provider>
  </form>
}

export default Form;

